var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconParainage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36396 5.05025C5.97344 4.65973 5.34027 4.65973 4.94975 5.05025C4.55922 5.44078 4.55922 6.07394 4.94975 6.46447L8.48528 10L4.94975 13.5355C4.55922 13.9261 4.55922 14.5592 4.94975 14.9497C5.34027 15.3403 5.97344 15.3403 6.36396 14.9497L9.89949 11.4142L13.435 14.9497C13.8256 15.3403 14.4587 15.3403 14.8492 14.9497C15.2398 14.5592 15.2398 13.9261 14.8492 13.5355L11.3137 10L14.8492 6.46447C15.2398 6.07394 15.2398 5.44078 14.8492 5.05025C14.4587 4.65973 13.8256 4.65973 13.435 5.05025L9.89949 8.58579L6.36396 5.05025Z",
    fill: "#1D3A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconParainage);
export default __webpack_public_path__ + "static/media/closeIconParainage.376b4812840d7f12526a9c135d8a110a.svg";
export { ForwardRef as ReactComponent };